import React, { useState } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { resolveImageUrl } from '../lib/imageUpload';

export const StudioCarousel = ({ images, alt = 'Studio', testid = 'studio-carousel' }) => {
  const pics = (images && images.length > 0) ? images : [];
  const [index, setIndex] = useState(0);

  if (pics.length === 0) {
    return <div className="h-96 bg-zinc-100" data-testid={`${testid}-empty`} />;
  }

  const go = (dir) => setIndex((i) => (i + dir + pics.length) % pics.length);

  return (
    <div className="relative h-96 overflow-hidden bg-zinc-100" data-testid={testid}>
      <img
        src={resolveImageUrl(pics[index])}
        alt={`${alt} ${index + 1}`}
        className="w-full h-full object-cover transition-opacity duration-300"
        data-testid={`${testid}-image`}
      />
      {pics.length > 1 && (
        <>
          <button
            type="button"
            onClick={() => go(-1)}
            className="absolute left-3 top-1/2 -translate-y-1/2 bg-white/80 hover:bg-white text-black rounded-full p-2 shadow transition-colors"
            data-testid={`${testid}-prev`}
            aria-label="Previous image"
          >
            <ChevronLeft size={20} />
          </button>
          <button
            type="button"
            onClick={() => go(1)}
            className="absolute right-3 top-1/2 -translate-y-1/2 bg-white/80 hover:bg-white text-black rounded-full p-2 shadow transition-colors"
            data-testid={`${testid}-next`}
            aria-label="Next image"
          >
            <ChevronRight size={20} />
          </button>
          <div className="absolute bottom-3 left-1/2 -translate-x-1/2 flex gap-2">
            {pics.map((_, i) => (
              <button
                key={i}
                type="button"
                onClick={() => setIndex(i)}
                className={`h-2 rounded-full transition-all ${i === index ? 'w-6 bg-[var(--accent)]' : 'w-2 bg-white/70'}`}
                aria-label={`Go to image ${i + 1}`}
              />
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default StudioCarousel;
